/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// import LinearProgress from "@material-ui/core/LinearProgress"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

/*psc regional routes*/
import regionalSuperAdmin from "routes/regional-admin.jsx";
import regionalVggUser from "routes/regional-vgg-user.jsx";
import regionalAccounts from "routes/regional-accounts.jsx"
import regionalAirline from "routes/regional-airline.jsx";
import regionalStaff from "routes/regional-staff.jsx";
import regionalAudit from "routes/regional-audit.jsx";
import regionalCreditControl from "routes/regional-credit-control.jsx";
import regionalFaanAdmin from "routes/regional-faan-admin.jsx";
import regionalExecutive from "routes/regional-executive.jsx";
import regionalSuperVisor from "routes/regional-supervisor.jsx";
import regionalHQSuperVisor from "routes/regional-HQ-supervisor.js";
import regionalAirportStaff from "routes/regional-airport-staff.jsx"

/*Routes for different users*/
import superAdminRoutes from "routes/dashboard.jsx";
import adminRoutes from "routes/admin.jsx";
import airlineRoutes from "routes/airline.jsx";
import staffRoutes from "routes/staff.jsx";
import airportManagerRoutes from "routes/airportManager.jsx";
import airportStaffRoutes from "routes/airportStaff.jsx";
import vggUserRoutes from "routes/vggUser.jsx";
import supervisorRoutes from "routes/supervisor.jsx";
import HQsupervisorRoutes from "routes/HQ-supervisor.js";
import creditControlRoutes from "routes/creditControl.jsx";
import accountRoutes from "routes/accounts.jsx";
import auditRoutes from "routes/audit.jsx";
import executiveRoutes from "routes/executiveUser.jsx";
import dashboardStyle from "assets/jss/material-dashboard-react/layouts/dashboardStyle.jsx";

import sidebarImage from "assets/img/sidebar.jpg";
import faanLogo from "assets/img/faan.png";
import { connect } from "react-redux";
import { store } from "../../_store";
import {alertActions, commonActions} from "../../_actions";
import { appHelpers, history } from '../../_helpers';
import { ProgressBar } from '../../utils/ProgressBar';
import AddAlert from "@material-ui/icons/AddAlert";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import { alertConstants, appConstants } from "../../_constants";

//Material-ui pickers
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
// pick utils
import MomentUtils from 'material-ui-pickers/utils/moment-utils';

const switchRoutes = (routes) => (
  <Switch>
    {routes.map((prop, key) => {
      if (prop.redirect)
        return <Redirect from={prop.path} to={prop.to} key={key} />;
      return <Route exact path={prop.path} component={prop.component} key={key} />;
    })}
  </Switch>
);

// remove designated links from routes
const setClientAdminRoutes = (routes) => {
  let clientAdminRoutes = routes.filter((route) => {
    // let subMenu = route.subMenu.filter(menu => {
    //   return menu.path !== "/app/billableSettings" &&
    //          menu.path !== "/app/airlineRouteSettings" &&
    //          menu.path !== "/app/pscSettings"
    // });
    
    // route.subMenu = subMenu;
    return route.path !== "/app/maker-checker"
        && route.path !== "/app/reconciliation"
        && route.path !== "/app/dataEntry"
        && route.path !== "/app/pdm"
        && route.path !== "/app/outstanding-settlement"

  });
  return clientAdminRoutes;
};

// remove designated links from regional routes
const setRegionalClientAdminRoutes = (routes) => {
  let regionalClientAdminRoutes = routes.filter((route) => {
    let subMenu = route.subMenu.filter(menu => {
      // return menu.path !== "/app/psc-regional/billableSettings" &&
      //   menu.path !== "/app/psc-regional/airlineRouteSettings" &&
      //   menu.path !== "/app/psc-regional/pscSettings" &&
       return menu.path !== "/app/psc-regional/exchangeRate"
  
    });
    route.subMenu = subMenu;
    return route.path !== "/app/psc-regional/maker-checker"
      && route.path !== "/app/psc-regional/reconciliation"
      && route.path !== "/app/psc-regional/dataEntry"
      && route.path !== "/app/psc-regional/pdm"
      && route.path !== "/app/psc-regional/outstanding-settlement"
    
  });
  return regionalClientAdminRoutes;
};

class App extends React.Component {
  timer = null;
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      completed: 0,
      notificationIsVisible: false,
      notificationMessage: ' ',
      notificationColor: 'success',
      user: false,
      sideBarRoutes: [],
    };
    this.resizeFunction = this.resizeFunction.bind(this);
  }
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute() {
    return this.props.location.pathname !== "/maps";
  }
  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }
  componentDidMount() {
    this.timer = setInterval(this.progress, 500);
    if (navigator.platform.indexOf("Win") > -1) {
      const ps = new PerfectScrollbar(this.refs.mainPanel);
    }
    window.addEventListener("resize", this.resizeFunction);

  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }
  componentWillReceiveProps = function (nextProps) {
    const { alert } = nextProps;
    if (alert) {
      if (alert.type === alertConstants.NOTIFY) {
        const msg_ = alert.message
        this.setState({ notificationMessage: msg_, notificationColor: 'success' });
        this.showNotification();
        this.props.dispatch(alertActions.clear());
      } else if (alert.type === alertConstants.ERROR) {
        const msg_ = (typeof alert.message === 'string') ? alert.message : 'Unable to process request';
        this.setState({ notificationMessage: msg_, notificationColor: 'danger' });
        this.showNotification();
        this.props.dispatch(alertActions.clear());
      }
    }
  };

  componentWillMount() {
    let { dispatch} = this.props;
    //check user is authenticated;
    const { user, setView, viewData } = store.getState();
    
    if (!user) {
      // Unauthorised user
      dispatch(alertActions.error(appConstants.APP_USER_SESSION_AUTHENTICATION_REQUIRED_MESSAGE));
      history.push('/login');

    } else {
      user.AppRole = appHelpers.interpretRole(viewData);
      
      let sideBarRoutes = airlineRoutes;
      if (user.AppRole === appConstants.ROLES.AIRLINE) {
        // sideBarRoutes = airlineRoutes;
        sideBarRoutes = (setView === 'regional') ? regionalAirline : airlineRoutes;
      } else if (user.AppRole === appConstants.ROLES.ADMIN) {
        sideBarRoutes = (setView === 'regional') ? regionalFaanAdmin : adminRoutes;
        // sideBarRoutes = adminRoutes;
      } else if (user.AppRole === appConstants.ROLES.SUPER_ADMIN) {
        // sideBarRoutes = setClientAdminRoutes(superAdminRoutes);
        sideBarRoutes = (setView === 'regional') ? setRegionalClientAdminRoutes(regionalSuperAdmin) : setClientAdminRoutes(superAdminRoutes);
      } else if (user.AppRole === appConstants.ROLES.STAFF) {
        // sideBarRoutes = staffRoutes;
        sideBarRoutes = (setView === 'regional') ? regionalStaff : staffRoutes;
      } else if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
        sideBarRoutes = airportManagerRoutes;
      } else if (user.AppRole === appConstants.ROLES.AIRPORT_STAFF) {
        sideBarRoutes = (setView === 'regional') ? regionalAirportStaff : airportStaffRoutes;
    
        // sideBarRoutes = airportStaffRoutes;
      } else if (user.AppRole === appConstants.ROLES.VGG_SUPERADMIN) {
        sideBarRoutes = vggUserRoutes;
      } else if (user.AppRole === appConstants.ROLES.VGG_ADMIN) {
        // sideBarRoutes = superAdminRoutes;
        sideBarRoutes = (setView === 'regional') ? regionalSuperAdmin : superAdminRoutes;
      } else if (user.AppRole === appConstants.ROLES.SUPERVISOR) {
        // sideBarRoutes = supervisorRoutes;
        sideBarRoutes = (setView === 'regional') ? regionalSuperVisor : supervisorRoutes;
      } else if (user.AppRole === appConstants.ROLES.HQ_SUPERVISOR) {
        // sideBarRoutes = supervisorRoutes;
        sideBarRoutes = (setView === 'regional') ? regionalHQSuperVisor : HQsupervisorRoutes;
      }
      else if (user.AppRole === appConstants.ROLES.CREDIT_CONTROL) {
        // sideBarRoutes = creditControlRoutes;
        sideBarRoutes = (setView === 'regional') ? regionalCreditControl : creditControlRoutes;
      } else if (user.AppRole === appConstants.ROLES.ACCOUNTS) {
        // sideBarRoutes = accountRoutes;
        sideBarRoutes = (setView === 'regional') ? regionalAccounts : accountRoutes;
      } else if (user.AppRole === appConstants.ROLES.AUDIT) {
        // sideBarRoutes = auditRoutes;
        sideBarRoutes = (setView === 'regional') ? regionalAudit : auditRoutes;
      } else if (user.AppRole === appConstants.ROLES.EXECUTIVE_USER) {
        // sideBarRoutes = executiveRoutes;
        sideBarRoutes = (setView === 'regional') ? regionalExecutive : executiveRoutes;
    
      } else if (user.AppRole === appConstants.ROLES.VGG_USER) {
        // sideBarRoutes = vggUserRoutes;
        sideBarRoutes = (setView === 'regional') ? regionalVggUser : vggUserRoutes;
    
      } else {
        dispatch(alertActions.error(appConstants.APP_USER_SESSION_UNAUTHORISED_ERROR_MESSAGE_2));
        history.push('/login');
      }
  
     
  
      this.setState({user, sideBarRoutes});
      const pageAuthorization = appHelpers.isAuthorised();
      if (!pageAuthorization || pageAuthorization === -1) {
        /* check if route exist */
        if (appHelpers.routeExist() !== -1) {
          dispatch(alertActions.error(appConstants.APP_USER_SESSION_UNAUTHORISED_ERROR_MESSAGE));
          history.push('/login');
        }
      }
  
  
      
      
    }
  }
  componentWillUnmount() {
    clearInterval(this.timer);
    window.removeEventListener("resize", this.resizeFunction);
  }
  clearAlertTimeout() {
    if (this.alertTimeout !== null) {
      clearTimeout(this.alertTimeout);
    }
  }
  showNotification() {
    this.setState({ notificationIsVisible: true });
    this.clearAlertTimeout();
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ notificationIsVisible: false });
      }.bind(this),
      10000
    );
  }
  render() {
    const { requesting, setView, classes, ...rest } = this.props;
    const { notificationMessage, notificationIsVisible, user, sideBarRoutes,
      notificationColor } = this.state;
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <div className={classes.wrapper}>

          <Sidebar
            routes={sideBarRoutes}
            logoText={user.fullName}
            logo={faanLogo}
            image={sidebarImage}
            handleDrawerToggle={this.handleDrawerToggle}
            open={this.state.mobileOpen}
            color={setView === "regional" ? "regional" : "green"}
            setView={setView}
            {...rest}
          />
          <div className={classes.mainPanel} ref="mainPanel">
            {/*<LoadingBar/>*/}
            <ProgressBar progress={requesting} />
            <Header
              routes={sideBarRoutes}
              handleDrawerToggle={this.handleDrawerToggle}
              {...rest}
              {...this.props}
            />
            {/* On the /maps route we want the map to be on full screen - this is not possible if the content and container classes are present because they have some paddings which would make the map smaller */}
            {this.getRoute() ? (
              <div className={classes.content}>
                <div className={classes.container}>{switchRoutes(sideBarRoutes)}</div>
              </div>
            ) : (
                <div className={classes.map}>{switchRoutes(sideBarRoutes)}</div>
              )}
            {this.getRoute() ? <Footer /> : null}
          </div>
          <Snackbar
            place="tr"
            color={notificationColor}
            icon={AddAlert}
            message={notificationMessage}
            open={notificationIsVisible}
            closeNotification={() => this.setState({ notificationIsVisible: false })}
            close
          />
        </div>
      </MuiPickersUtilsProvider>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
  const { user, requesting, alert, setView, viewData} = state;
  return {
    user,
    requesting,
    alert,
    setView,
    viewData
  };
}
export default connect(mapStateToProps)((withStyles(dashboardStyle)(App)));



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx